<template>
  <div id="us-home" style="padding-top:100px;">
    准备授权...
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {

  },
  created() {

    var that = this

    console.log('call_url', that.$route.query.call_url)
    var queryData = JSON.stringify(that.$route.query)
    // console.log('queryData', that.$route.query);
    that.$api.gzh.auth({ query_data: queryData }).then(res => {
      // console.log('auth.res', JSON.stringify(res))
      var data = res.data
      location.href = data.auth_url
    })
  }
}
</script>

<style scoped>
#us-home {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 30px;
}

.us-nav-content {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>
